/**
 * @generated SignedSource<<34fdbfcb9d2dad189c444493585d79a7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type editGroupModal_UserInAccountGroupFragment$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "editGroupModal_UserInAccountGroupFragment";
};
export type editGroupModal_UserInAccountGroupFragment$key = {
  readonly " $data"?: editGroupModal_UserInAccountGroupFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"editGroupModal_UserInAccountGroupFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "editGroupModal_UserInAccountGroupFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "UserInAccountGroup",
  "abstractKey": null
};

(node as any).hash = "a9386be69fb2c56471ee2423eaa90664";

export default node;
